if (!customElements.get('product-description-expand')) {
  customElements.define(
    'product-description-expand',
    class ProductDescriptionExpand extends HTMLElement {
      connectedCallback() {
        const showButton = this.querySelector('.product-description__show');
        const textContainer = this.querySelector('.product-description__text');

        if (!showButton || !textContainer) return;

        showButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.classList.remove('product-description--clamped');
          showButton.setAttribute('aria-expanded', 'true');
          textContainer.setAttribute('aria-expanded', 'true');
        });
      }
    }
  );
}
